import styled from 'styled-components';
import Header from 'js/components/core/Header';
import { lightGrey1Color } from 'js/config/style';

export default styled(Header)`
  height: 2.5rem;
  line-height: 2.5rem;
  position: relative;
  border-bottom: 1px solid ${lightGrey1Color};
`;
